<template>

    <div class="page">

        <div v-if="loading" class="loading">

            <lottie-loader></lottie-loader>

        </div>

        <div v-else class="stats">

            <header-band v-show="isDesktop" :title="$t('statistics_page_name')"></header-band>

            <div class="container">

                <div class="sky">
                    <div class="content">
                        <div class="happy-foxy">
                            <img src="/img/stats/foxy-smile.svg">
                        </div>
                        <div class="details">
                            <markdown class="text-baseRegular color__white"
                                      :class="{'text-baseRegular': !isDesktop, 'text-lRegular' : isDesktop}"
                                      :text="titleFirstname"></markdown>
                        </div>
                    </div>
                    <div class="fake-bottom"></div>
                </div>

                <main class="column">

                    <div>

                        <article class="article-1" v-show="itsMyFirstTime">

                            <div class="row">
                                <div class="bloc bloc-style-1">
                                        <p class="info">{{ maxStatsDeleted }}</p>
                                        <p class="detail">{{
                                                $tc('statistics_mails_deleted', globalDeletedNewsletters)
                                            }}</p>
                                    <img src="/img/stats/trash-white.svg">
                                </div>
                                <div class="bloc bloc-style-2">
                                    <span
                                        class="info">{{ octetConverter(incrementData(globalStorageSavedInKo)) }}</span>
                                    <span class="detail">{{ $t('statistics_space_saved') }}</span>
                                    <img src="/img/stats/foxy-party.svg">
                                </div>
                            </div>

                            <div class="row">
                                <div class="bloc bloc-style-3">
                                    <span class="info">{{ incrementData(globalAverageNewslettersPerAccount) }}</span>
                                    <span class="detail">{{ $t('statistics_newsletters_average') }}</span>
                                    <img src="/img/stats/mailbox-full.svg">
                                </div>
                            </div>
                        </article>


                        <article class="article-1" v-show="!itsMyFirstTime">
                            <div class="row">
                                <div class="bloc bloc-style-7">
                                    <p>
                                        <span class="info">{{ incrementData(userAutoDeletedNewsletters) }}</span>
                                        <span
                                            class="detail">{{
                                                $tc('statistics_autodelete', userAutoDeletedNewsletters)
                                            }}</span>
                                    </p>
                                    <img src="/img/stats/trash-white.svg">
                                </div>
                                <div class="bloc bloc-style-4">
                                    <p>
                                        <span class="info">{{ incrementData(userDeletedMails) }}</span>
                                        <span class="detail">{{
                                                $tc('statistics_mail_deleted', userDeletedMails)
                                            }}</span>
                                    </p>
                                    <img src="/img/stats/mailbox-empty.svg">
                                </div>
                            </div>

                            <div class="row">
                                <div class="bloc bloc-style-5">
                                    <span class="info">{{ incrementData(userTreatedNewsletters) }}</span>
                                    <span
                                        class="detail">{{
                                            $tc('statistics_newsletters_sorted', userTreatedNewsletters)
                                        }}</span>
                                    <img src="/img/stats/foxy-party.svg">
                                </div>
                                <div class="bloc bloc-style-6">
                                    <span class="info">{{ incrementData(userRemainsMailsToTreat) }}</span>
                                    <span class="detail">{{
                                            $tc('statistics_mails_to_sort', userRemainsMailsToTreat)
                                        }}</span>
                                    <img :src="`/img/stats/envelopes${isDesktop ? '-desktop': ''}.svg`">
                                </div>
                            </div>

                            <div class="row">
                                <div class="share">
                                    <markdown :text="$t('statistics_share')"
                                              class="text-baseRegular color__white mr__16"></markdown>
                                    <button class="cta-small-primary cta-content" @click="openShareStatsImage">
                                        <span>{{ $t('menu_share') }}</span>
                                        <img src="/img/stats/share-white.svg">
                                    </button>
                                </div>
                            </div>
                        </article>

                        <stats-carousel></stats-carousel>

                        <div class="sponsorship-bg">
                            <div class="sponsorship">

                                <img src="/img/stats/people.svg" class="people">

                                <span class="title-baseSemibold mt__16">{{ $t('statistics_referral_title') }}</span>
                                <span class="text-lRegular mt__8">{{ $t('statistics_referral_tree') }}</span>

                                <div class="copy-bloc noselect" v-if="user.partnerCode" @click="copyCode">
                                    <img :src="copyBlocImage" class="img__20">
                                    <div class="code">
                                        <span class="text-sSemibold color__moon"
                                              :class="{'color__lime': codeCopied}">{{ copyBlocText }}</span>
                                        <span class="text-xlSemibold color__charcoal">{{ user.partnerCode }}</span>
                                    </div>
                                    <div @click.stop="openShareStatsImage" class="round-blue">
                                        <img src="/img/stats/share-white.svg" class="img__20">
                                    </div>
                                </div>
                                <div v-else class="no-partner-code">
                                    <span
                                        class="text-baseSemibold color__moon mr__16">{{
                                            $t('statistics_referral_sponsor_generating')
                                        }}</span>
                                    <lottie-loader :size="32"></lottie-loader>
                                </div>

                                <div class="separator"></div>

                                <markdown v-show="referrals.referrals.length"
                                          class="text-lRegular mt__24"
                                          :text="$tc('referral_nb_referred', referrals.referrals.length, {nb_sponsored: referrals.referrals.length, trees: referrals.referrals.length})"></markdown>

                                <button class="cta-medium-tertiary cta-full mt__24" @click="goSponsorship">
                                    <span>{{ $t('stats_see_more') }}</span>
                                    <img src="/img/stats/chevron-blue-right.svg">
                                </button>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
        <share-stats-image ref="SSI"></share-stats-image>
    </div>

</template>

<script>

import Vuex from 'vuex'

import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import HeaderBand from '../components/headers/HeaderBand'
import LottieLoader from '../components/lottie/LottieLoader'
import Markdown from '../components/Markdown'
import ShareStatsImage from '../components/ShareStatsImage'
import StatsCarousel from '../components/stats/Carousel'

export default {

    name: 'stats',

    components: {
        HeaderBand,
        LottieLoader,
        Markdown,
        ShareStatsImage,
        StatsCarousel
    },

    watch: {
        stats(newValue) {
            if (newValue && this.loading) {
                this.startPage()
            }
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'newsletters',
            'referrals',
            'stats',
            'user'
        ]),

        itsMyFirstTime() {
            return this.stats.user && this.stats.user.treatedNewsletters === 0
        },

        copyBlocImage() {
            return this.codeCopied ? '/img/stats/check-circle-green.svg' : '/img/stats/copy-grey.svg'
        },

        copyBlocText() {
            return this.codeCopied ? this.$t('we_forest_code_copied') : this.$t('we_forest_code')
        },

        titleFirstname() {
            return this.itsMyFirstTime
                ? this.$tc('statistics_figures_users', 0, {firstName: this.user.firstname})
                : this.$tc('statistics_space_won', this.userStorageSavedInKo, {
                    firstName: this.user.firstname,
                    number: this.octetConverter(this.userStorageSavedInKo)
                })
        },

        globalDeletedNewsletters() {
            return this.stats.global && this.stats.global.deletedMails || 0
        },
        globalStorageSavedInKo() {
            return this.stats.global && this.stats.global.storageSavedInKo || 0
        },
        globalAverageNewslettersPerAccount() {
            return this.stats.global && this.stats.global.averageNewslettersPerAccount || 0
        },

        userAutoDeletedNewsletters() {
            return this.stats.user && this.stats.user.autoDeletedNewsletters || 0
        },
        userDeletedMails() {
            return this.stats.user && this.stats.user.deletedMails || 0
        },
        userStorageSavedInKo() {
            return this.stats.user && this.stats.user.storageSavedInKo || 0
        },
        userTreatedNewsletters() {
            return this.stats.user && this.stats.user.treatedNewsletters || 0
        },
        userRemainsMailsToTreat() {
            return this.stats.user && this.stats.user.remainsMailsToTreat || 0
        },
        trackingPageName() {
            return this.itsMyFirstTime ? 'stats_empty' : 'stats'
        },

        maxStatsDeleted() {
            const count = (this.globalDeletedNewsletters/1000000000).toFixed()
            return `${this.incrementData(count)} ${this.$tc('statistics_mails_deleted_billion', count)}`
        }


    },

    data() {
        return {
            loading: true,
            codeCopied: false,
            percent: 0,
            timeToIncrement: 5
        }
    },

    mounted() {
        UserFlow.setPage(this, 'stats')

        this.getStatsAsync()
        this.getUserAsync()
        this.getReferralsAsync()

        if (this.stats.user) {
            this.startPage()
        }
    },

    methods: {

        ...Vuex.mapActions([
            'getStatsAsync',
            'getUserAsync',
            'getReferralsAsync'
        ]),

        startPage() {
            Tag.pageViewGA(this, this.trackingPageName)
            this.loading = false
            this.startIncrement()
        },

        incrementData(data, toFixed = false) {

            if (this.percent && data) {
                const value = data / 100 * this.percent
                return toFixed ? Number.parseFloat(value).toFixed(2) : Math.floor(value)
            }
            return 0
        },

        startIncrement() {

            setInterval(() => {
                if (this.percent < 100) {
                    this.percent = this.percent + 1
                }
            }, this.timeToIncrement)
        },

        copyCode() {
            const element = document.createElement('textarea')
            element.value = this.user.partnerCode
            document.body.appendChild(element)
            element.select()
            document.execCommand('copy')
            document.body.removeChild(element)
            this.codeCopied = true

            Tag.clickAll(this, 'copy_code', null, this.trackingPageName)
        },

        goSponsorship() {
            Tag.clickAll(this, 'see_more_referral', null, this.trackingPageName)
            this.$router.push({path: '/sponsorship'})
        },

        openShareStatsImage() {
            Tag.clickAmplitude(this, 'share_my_stats', null, this.trackingPageName)
            this.$refs.SSI.open()
        }
    }

}
</script>

<style lang="scss" scoped>

.page {
    display: flex;
    flex-grow: 1;
    align-items: center;
    width: 100%;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }

    .loading {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
    }

    .stats {
        display: flex;
        flex-grow: 1;
        flex-direction: column;
        align-items: center;
        background-color: $timberwolf;
        @media screen and (min-width: $above-tablet-length) {
            width: 100%;
        }

        .container {
            display: flex;
            flex-direction: column;

            @media screen and (min-width: $above-tablet-length) {
                max-width: 408px;
                margin: 56px 0;
            }

            .sky {
                display: flex;
                flex-direction: column;
                background: linear-gradient(180deg, #5AB1E9 0%, #9FCEED 100%);
                min-height: 170px;
                justify-content: flex-end;
                @media screen and (min-width: $above-tablet-length) {
                    border-radius: 24px;
                }


                .content {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin: 0 40px -52px;

                    .happy-foxy {
                        padding-right: 24px;
                        margin-bottom: 1px;
                        @media screen and (min-width: $above-tablet-length) {
                            margin-bottom: -2px;
                        }

                        > img {
                            width: 95px;
                            object-fit: contain;
                            z-index: 1;
                            position: relative;
                            @media screen and (min-width: $above-tablet-length) {
                                width: 101px;
                            }
                        }
                    }

                    .details {
                        padding-bottom: 40px;
                        text-align: start;
                    }
                }

                .fake-bottom {
                    background-color: $white;
                    padding-top: 40px;
                    border-radius: 32px 32px 0 0;
                    @media screen and (min-width: $above-tablet-length) {
                        display: none;
                    }
                }
            }

            .column {
                display: flex;
                flex-direction: column;
                background-color: $white;
                max-width: 100vw;
                @media screen and (min-width: $above-tablet-length) {
                    background-color: $timberwolf;
                }

                .article-1 {
                    padding-bottom: 30px;
                    @media screen and (min-width: $above-tablet-length) {
                        margin-top: 16px;
                    }
                }

                .row {
                    padding: 0 12px;
                    display: flex;
                    flex-direction: row;

                    @media screen and (min-width: $above-tablet-length) {
                        padding: 0;
                    }

                    .bloc {
                        flex: 1;
                        padding: 16px;
                        border-radius: 24px;
                        height: 180px;
                        margin: 4px;
                        position: relative;
                        color: $midnight;
                        overflow: hidden;
                        word-break: break-word;
                        @media screen and (min-width: $above-tablet-length) {
                            width: 196px;
                            height: 190px;
                        }

                        > img {
                            position: absolute;
                            bottom: 0;
                        }

                        .info {
                            z-index: 1;
                            font-size: 28px;
                            font-weight: 700;
                            @media screen and (min-width: $above-tablet-length) {
                                font-size: 32px;
                                font-weight: 700;
                                line-height: 40px;
                            }
                        }

                        .detail {
                            z-index: 1;
                            font-size: 12px;
                            font-weight: 600;
                            line-height: 16px;
                            @media screen and (min-width: $above-tablet-length) {
                                font-size: 15px;
                                font-weight: 600;
                                line-height: 20px;
                            }
                        }

                        > p {
                            height: fit-content;
                            display: flex;
                            align-items: center;
                        }
                    }

                    .bloc-style-1 {
                        background: linear-gradient(180deg, #6EBAEA 0%, #90C8EC 100%);
                        display: flex;
                        flex-direction: column;
                        text-align: start;
                        align-items: center;

                        span:first-child {
                            margin-right: 6px;
                        }

                        p {
                            width: 100%;
                        }

                        > img {
                            @media screen and (min-width: $above-tablet-length) {
                                width: 91px
                            }
                        }
                    }

                    .bloc-style-2 {
                        background: linear-gradient(180deg, #5EA774 0%, #79A75E 100%);
                        display: flex;
                        flex-direction: column;
                        align-items: end;
                        text-align: right;

                        > img {
                            left: 9px;
                            @media screen and (min-width: $above-tablet-length) {
                                width: 112px;
                            }
                        }
                    }

                    .bloc-style-3 {
                        background-color: $midnight;
                        color: $white;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        text-align: start;

                        span:nth-child(2) {
                            max-width: 50%;
                        }

                        > img {
                            right: 14px;
                        }
                    }

                    .bloc-style-4 {
                        background: linear-gradient(180deg, #5EA774 0%, #79A75E 100%);
                        color: $white;
                        display: flex;
                        flex-direction: row;

                        > img {
                            right: 8px;
                        }

                        span:first-child {
                            margin-right: 6px;
                        }
                    }

                    .bloc-style-5 {
                        background-color: $rifle;
                        color: $white;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        text-align: end;

                        > img {
                            left: 8px;
                            width: 112px;
                            @media screen and (min-width: $above-tablet-length) {
                                width: 112px;
                            }
                        }
                    }

                    .bloc-style-6 {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        background: linear-gradient(180deg, #6EBAEA 0%, #90C8EC 100%);

                        > img {
                            right: 0;
                            bottom: 0;
                            @media screen and (min-width: $above-tablet-length) {
                                width: 192px;
                            }
                        }
                    }
                }

                .bloc-style-7 {
                    background: linear-gradient(180deg, #6EBAEA 0%, #90C8EC 100%);
                    display: flex;
                    flex-direction: row;
                    text-align: start;
                    justify-content: center;

                    span:first-child {
                        margin-right: 6px;
                    }

                    > img {
                        @media screen and (min-width: $above-tablet-length) {
                            width: 91px
                        }
                    }
                }

                .share {
                    margin: 4px;
                    border-radius: 24px;
                    padding: 24px 16px;
                    background-color: $midnight;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    text-align: start;
                }

                .sponsorship-bg {
                    background: linear-gradient(126deg, #2B6C5D 0%, #2C556A 100%);
                    @media screen and (min-width: $above-tablet-length) {
                        border-radius: 24px;
                        overflow: hidden;
                    }

                    .sponsorship {
                        padding: 48px 32px 48px;
                        display: flex;
                        flex-direction: column;
                        position: relative;
                        color: $white;
                        background-image: url("/img/stats/sponsorship-bg.svg");
                        background-size: contain;
                        background-repeat: no-repeat;
                        background-position: bottom;

                        .people {
                            height: 56px;
                            object-fit: contain;
                        }

                        .copy-bloc {
                            margin-top: 24px;
                            padding: 12px 16px;
                            border-radius: 12px;
                            background-color: $white;
                            display: flex;
                            flex-direction: row;
                            cursor: pointer;

                            .code {
                                margin: 0 8px;
                                display: flex;
                                flex-direction: column;
                                text-align: start;
                                flex: 1;
                            }

                            .round-blue {
                                padding: 12px;
                                border-radius: 40px;
                                background-color: $aquamarine;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }

                        .no-partner-code {
                            margin-top: 24px;
                            padding: 12px 16px;
                            background-color: $white;
                            border-radius: 12px;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                        }

                        .separator {
                            height: 1px;
                            width: 100%;
                            background-color: #3A8978;
                            margin-top: 24px;
                        }
                    }
                }
            }
        }

    }


}

/*animation*/

.desktop-hidden {
    @media screen and (min-width: $above-tablet-length) {
        opacity: 0;
    }
}

.blociscomming-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.blociscomming-enter {
    transform: translate(0, 50px);
    opacity: 0;
}

.desktop-animation-show {
    @media screen and (min-width: $above-tablet-length) {
        animation: animdesktopshow 200ms ease-in-out 50ms 1 normal forwards;
    }
}

@keyframes animdesktopshow {

    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

</style>
